export default __webpack_public_path__ + "static/media/triangle2.76663b92.svg";